export function toQuotedString(s: string): string {
  return JSON.stringify(s);
}
